module.exports = __webpack_public_path__ + "img/checked.55bdf69c.svg";